import { ACTOR } from '../constants/actors';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
export const actorToApprovalUser = (actor, usersRecord) => {
  const {
    actorType,
    id
  } = actor;
  if (typeof actorType === 'symbol') {
    return {
      actor: {
        actorType: ACTOR.USER,
        id
      },
      email: '',
      firstName: `Unknown actor`,
      lastName: `(${id})`
    };
  }
  switch (actorType) {
    case ACTOR.USER:
      {
        var _user$email, _user$firstName, _user$lastName;
        const userId = Number(id);
        const user = usersRecord[userId];
        return {
          // TODO: Remove activeUserId once settings-ui-quotes is updated to use actor.id
          activeUserId: userId,
          actor: {
            actorType: ACTOR.USER,
            id
          },
          email: (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : '',
          firstName: (_user$firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : '',
          lastName: (_user$lastName = user === null || user === void 0 ? void 0 : user.lastName) !== null && _user$lastName !== void 0 ? _user$lastName : ''
        };
      }
    case ACTOR.AGENT:
      return {
        actor: {
          actorType: ACTOR.AGENT,
          id
        },
        email: '',
        firstName: 'Agent',
        lastName: `Perry (${id})`
      };
    default:
      return unreachableFallback(actorType, {
        actor: {
          actorType,
          id
        },
        email: '',
        firstName: `Unknown actor`,
        lastName: `(${id})`
      });
  }
};
export const chirpApprovalToApprovalData = (chirpApproval, usersRecord, approvalType, approvalAction) => {
  var _chirpApproval$approv, _chirpApproval$reques, _chirpApproval$cancel, _chirpApproval$dueDat, _ref;
  return {
    id: chirpApproval.id,
    portalId: chirpApproval.portalId,
    title: chirpApproval.title,
    createDateTimestamp: chirpApproval.createDateTimestamp,
    // TODO Remove type cast when we've fully migrated to CHIRP
    approvalStatus: chirpApproval.approvalStatus,
    approvalType,
    approvalAction,
    // TODO Remove type cast when we've fully migrated to CHIRP
    approvalRules: chirpApproval.approvalRules,
    requester: actorToApprovalUser(chirpApproval.requester, usersRecord),
    approvalSteps: ((_chirpApproval$approv = chirpApproval.approvalSteps) !== null && _chirpApproval$approv !== void 0 ? _chirpApproval$approv : []).map(step => {
      var _step$approvedNote, _step$rejectionNote;
      return {
        id: step.id,
        approver: actorToApprovalUser(step.approver, usersRecord),
        // TODO Remove type cast when we've fully migrated to CHIRP
        approvalStepStatus: step.approvalStepStatus,
        createDateTimestamp: step.createDateTimestamp,
        approvedNote: (_step$approvedNote = step.approvedNote) !== null && _step$approvedNote !== void 0 ? _step$approvedNote : '',
        approvedNoteTimestamp: null,
        rejectionNote: (_step$rejectionNote = step.rejectionNote) !== null && _step$rejectionNote !== void 0 ? _step$rejectionNote : null
      };
    }),
    requestNote: (_chirpApproval$reques = chirpApproval.requestNote) !== null && _chirpApproval$reques !== void 0 ? _chirpApproval$reques : '',
    cancelNote: (_chirpApproval$cancel = chirpApproval.cancelNote) !== null && _chirpApproval$cancel !== void 0 ? _chirpApproval$cancel : null,
    cancelNoteTimestamp: null,
    dueDate: (_chirpApproval$dueDat = chirpApproval.dueDate) !== null && _chirpApproval$dueDat !== void 0 ? _chirpApproval$dueDat : null,
    approvalConcluded: Boolean(chirpApproval.approvalConcluded),
    approvalConclusionReason: // TODO Remove type cast when we've fully migrated to CHIRP
    (_ref = chirpApproval.approvalConclusionReason) !== null && _ref !== void 0 ? _ref : null
  };
};